import {
  Box,
  Button,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import Page from "src/components/Page";
const NotFoundView = ({ message, ...rest }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Page title="404: Not found">
      <Container maxWidth="lg">
        <Typography
          align="center"
          variant={mobileDevice ? "h4" : "h1"}
          color="text.primary"
        >
          {t("404: La página que buscas no existe.")}
        </Typography>
        <Typography align="center" variant="subtitle2" color="text.secondary">
          {message
            ? message
            : t(
                "You either tried some shady route or you" +
                  "came here by mistake. Whichever it is, try using the navigation.",
              )}
        </Typography>
        <Box
          sx={{
            mt: 6,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            alt="Not found"
            src="/static/images/undraw_page_not_found_su7k.svg"
            style={{ maxWidth: "60%", width: "100%", height: "auto" }}
          />
        </Box>
        <Box
          sx={{
            mt: 6,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            color="secondary"
            component={RouterLink}
            to="/app"
            variant="outlined"
          >
            {t("Volver al inicio")}
          </Button>
        </Box>
      </Container>
    </Page>
  );
};

export default NotFoundView;
